import './style.scss';
import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

// Initialise component with Splide setup
const init = (cmpnt, selector, instances) => {
  const carouselEl = cmpnt.querySelector(`.${selector}-carousel`);

  if (!carouselEl) return;

  const splide = new Splide('.splide', {
    type: 'slide',
    autoWidth: true,
    gap: '1rem',
    pagination: false,
    arrows: false,
    drag: true,
    trimSpace: true,
//    focus: 'center',
/*    breakpoints: {
      991: {
        focus: 'center',
      },
    },
*/
  });

  const prevButton = cmpnt
    .closest(`.${selector}`)
    .parentElement.querySelector('.gallery_carousel-arrow.prev');
  const nextButton = cmpnt
    .closest(`.${selector}`)
    .parentElement.querySelector('.gallery_carousel-arrow.next');

  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => splide.go('<'));
    nextButton.addEventListener('click', () => splide.go('>'));
  }

  splide.mount();

  window.addEventListener('resize', () => {
    splide.refresh();
  });
};

// Find each component and initialise
// Wait for DOM content to be fully loaded
document.addEventListener('DOMContentLoaded', () => {
  const selector = 'gallery_carousel';
  const instances = document.querySelectorAll(`.${selector}`);

  instances.forEach(cmpnt => init(cmpnt, selector, instances));
});
